import type { Session } from '../../domain/entities/session';
import type { AuthRepository } from '../../domain/ports/auth-repository';
import type { SessionFactory } from '../ports/session-factory';

export interface VerifyMfaInput {
  mfaToken: string;
  code: string;
  email: string;
}

interface VerifyMfaUseCaseDeps {
  authRepository: AuthRepository;
  createSession: SessionFactory;
}

export async function verifyMfaUseCase(
  input: VerifyMfaInput,
  deps: VerifyMfaUseCaseDeps,
): Promise<Session> {
  const result = await deps.authRepository.verifyMfa({
    mfaToken: input.mfaToken,
    code: input.code,
  });
  const session = deps.createSession({ ...result, email: input.email });
  if (!session) throw new Error('invalid token in response');

  return session;
}
